//@ts-nocheck

import React from 'react';

import TitleBox from '../../components/TitleBox';
import Icon1 from "../../assets/imgs/icon-deposit.png";
import Icon2 from "../../assets/imgs/icon-accumulate.png";
import Icon3 from "../../assets/imgs/icon-points.png";
import BgCard from "../../assets/imgs/bg-card.svg";


const steps = [
	{
		img: Icon1,
		title: "Globalization",
		desc: "Deploy tokenized loyalty programs with cross-border interoperability, reducing transaction costs by 60%."
	},
	{
		img: Icon2,
		title: "Optimization",
		desc: "Automate multilingual sentiment analysis for global brand monitoring across 50+ markets with real-time insights."
	},
	{
		img: Icon3,
		title: "Localization",
		desc: "Localize eCommerce platforms for APAC market entry, increasing conversions by 40% through cultural adaptation."
	},
];

const HowTo = () => {

	return (
		<div id="download" className='w-full px-[20px] pt-[80px] lg:pt-[160px]'>
			<div className='max-w-full w-[1440px] mx-auto flex flex-col justify-center items-center gap-4'>
				<div className='cursor-pointer' onClick={() => window.open("https://play.google.com/store/apps/details?id=com.mobilerivals.rivalshield", "_blank")}>
					<TitleBox text="Download" />
				</div>
				<div className='text-[24px] lg:text-[32px] text-center font-[500] bg-gradient-to-b from-[#FFFFFF] to-[#999999] bg-clip-text text-transparent'>
					Download RivalShield VPN today and turn your device into a fortress. <br />Your security is our mission.
				</div>
				<div className='w-full flex scale-90 lg:scale-100 flex-col lg:flex-row gap-[36px] lg:gap-[42px] justify-center items-center mt-[-50px] lg:mt-[50px]'>
					{steps.map((item, index) =>
					(
						<div key={index} className='relative w-[383px] h-[477px] px-[24px] flex flex-col justify-start items-center overflow-hidden bg-gradient-to-b from-[#1E1E1E] to-[#151515] border-t-4 border-[rgba(255,192,0,1)] rounded-b-[20px] hover:scale-110 transition-all duration-500'>
							<img src={BgCard} className='w-[409px] absolute top-[-20px] left-0 z-10' alt='bg' />
							<div className='text-white text-[16px] mt-[20px] z-20'>&nbsp;</div>
							<img src={item.img} className='w-[98px] h-[98px] mt-[30px] z-20' alt='flash' />
							<div className='text-white text-center text-[24px] mt-[65px] z-20'>{item.title}</div>
							<div className='text-[#B3B3B3] text-center text-[16px] font-[400] mt-[16px]'>{item.desc}</div>
						</div>
					)
					)}
				</div>
			</div>
		</div>
	);
};

export default HowTo;
